import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

// Styled Components
import {
  Container,
  ContainerLoader,
  Icon,
  ModalContainerStyled,
  Title,
  TeamName,
  ButtonContainer,
} from './styles';

// Types
import { ModalProps } from './types';

// Components
import { MainButton } from '../../../inputs/buttons/MainButton';
import { Loader } from '../../../inputs/Loader';

// Icon
import AlertIcon from '../../../../assets/icons/alert-icon.svg';

export const DeleteTeamModal = ({
  onClickClose,
  teamName,
  onConfirmDelete,
  isLoading: isLoadingProp,
  ...props
}: ModalProps): JSX.Element => {
  const { t } = useTranslation(['management', 'common']);
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(isLoadingProp || false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      await onConfirmDelete();
      onClickClose();
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainerStyled
      width={50}
      onClickClose={onClickClose}
      fill={theme.colors.black}
    >
      {isLoading && (
        <ContainerLoader>
          <Loader />
        </ContainerLoader>
      )}
      <Icon src={AlertIcon} isLoading={isLoading} />
      <Container {...props} isLoading={isLoading}>
        <Title variant="semiBold">
          {t('teams.deleteConfirmation', '¿Estás seguro de que deseas eliminar este equipo?')}
        </Title>
        <TeamName variant="semiBold">{teamName}</TeamName>
        <Title size="S">
          {t('teams.deleteWarning', 'Esta acción no se puede deshacer. Los usuarios y vehículos asociados serán desvinculados del equipo.')}
        </Title>
        <ButtonContainer>
          <MainButton
            text={t('common:buttons.cancel', 'Cancelar')}
            variant="secondary"
            onClick={onClickClose}
            disabled={isLoading}
          />
          <MainButton
            text={isLoading ? t('common:buttons.deleting') : t('common:buttons.delete', 'Eliminar')}
            variant="primary"
            onClick={handleDelete}
            disabled={isLoading}
          />
        </ButtonContainer>
      </Container>
    </ModalContainerStyled>
  );
};
